import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { useFormatNumber, useI18n } from '@udemy-v2/i18n';
import { UFBNoticeButton } from '@udemy-v2/organization-growth';
import React from 'react';
import styles from './marketplace-ufb-notice.module.scss';
import { CtaPlacement, useUbCtaParams } from '../../hooks/use-ub-cta-href';
import { useOrganizationStats } from '@udemy-v2/site-stats';
export const MarketplaceUfbNotice = () => {
  const $ = _c(27);
  const {
    gettext,
    interpolate,
    locale
  } = useI18n();
  const {
    numCoursesRounded
  } = useOrganizationStats();
  const {
    formatNumber
  } = useFormatNumber();
  const formattedNumCoursesRounded = formatNumber(numCoursesRounded);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ctaPlacement: CtaPlacement.NON_PP_TRANSACTION
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    ubHref,
    eventData
  } = useUbCtaParams(t0);
  let href;
  let t1;
  let t2;
  let t3;
  if ($[1] !== gettext || $[2] !== interpolate || $[3] !== locale || $[4] !== ubHref) {
    const config = {
      ja_JP: {
        href: "https://ufb.benesse.co.jp/?ref=marketplace_control_lifestyle&amp;utm_source=marketplace&amp;utm_medium=referral&amp;utm_campaign=mx-hooks&amp;utm_content=clp&amp;utm_term=&amp;locale=ja_JP",
        minTeamUserCount: 20
      },
      default: {
        href: ubHref,
        minTeamUserCount: 5
      }
    };
    const {
      href: t4,
      minTeamUserCount
    } = config[locale as keyof typeof config] || config.default;
    href = t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = classNames(styles["notice-container"]);
      t1 = classNames("ud-heading-lg");
      $[9] = t1;
      $[10] = t3;
    } else {
      t1 = $[9];
      t3 = $[10];
    }
    t2 = interpolate(gettext("Training %(minTeamUserCount)s or more people?"), {
      minTeamUserCount
    }, true);
    $[1] = gettext;
    $[2] = interpolate;
    $[3] = locale;
    $[4] = ubHref;
    $[5] = href;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    href = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t2) {
    t4 = <h2 className={t1}>{t2}</h2>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classNames("ud-text-sm");
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = interpolate(gettext("Get your team access to %(courseCount)s+ top Udemy courses anytime, anywhere."), {
    courseCount: formattedNumCoursesRounded
  }, true);
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <p className={t5}>{t6}</p>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = classNames(styles["notice-button"]);
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== eventData || $[20] !== href) {
    t9 = <UFBNoticeButton className={t8} href={href} udStyle="secondary" eventData={eventData} />;
    $[19] = eventData;
    $[20] = href;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== t7 || $[25] !== t9) {
    t10 = <div className={t3}>{t4}{t7}{t9}</div>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t7;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};